import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import { type PromoActions } from '@/components_new/PromoItems/types'
import { useGeneralData } from '@/query/use-general-data'
import { useLayoutStore } from '@/store/layout-store'
import { useLoggerStore } from '@/store/logger'
import { formatValue } from '@/utils/numbers'

export const usePromoStore = defineStore('promo', () => {
    const { mainData } = useGeneralData()
    const p2eBonusInfo = computed(() => mainData.value.p2eBonusInfo)
    const inviteBonus = computed(() => formatValue(p2eBonusInfo.value?.inviteBonus))
    const inviteBonusShort = computed(() => formatValue(p2eBonusInfo.value?.inviteBonus, { shorten: true }))
    const signInBonus = computed(() => formatValue(p2eBonusInfo.value?.signInBonus))
    const signInBonusShort = computed(() => formatValue(p2eBonusInfo.value?.signInBonus, { shorten: true }))
    const shouldShowAddGameBanner = ref<boolean | null>(null)
    const { setInviteModalOpened, setSignInModalOpened } = useLayoutStore()
    const loggerStore = useLoggerStore()

    function setPromoAction(action: PromoActions) {
        if (action === 'sign_in') {
            setSignInModalOpened(true)

            loggerStore.logEvent({
                event: 'custom_event',
                eventName: 'sign-in',
                action: 'click',
            })
        }
        if (action === 'invite') {
            setInviteModalOpened(true)

            loggerStore.logEvent({
                event: 'custom_event',
                eventName: 'invite-friend',
                action: 'click',
            })
        }
    }

    return {
        setPromoAction,
        shouldShowAddGameBanner,
        inviteBonus,
        signInBonus,
        inviteBonusShort,
        signInBonusShort,
    }
})
